export default __webpack_public_path__ + "static/media/gallery-1.58aba489.jpg";